
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-transformer.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-transformer.md?type=demo')
};